import { render } from "./ExpertStatisticsUserReport.vue?vue&type=template&id=b651e24a"
import script from "./ExpertStatisticsUserReport.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsUserReport.vue?vue&type=script&lang=js"

import "./ExpertStatisticsUserReport.vue?vue&type=style&index=0&id=b651e24a&lang=css"
script.render = render

export default script